import { useState } from "react";
import type { Episode } from "@/types/catalog";

interface EpisodeListProps {
  episodes: Episode[];
}

export default function EpisodeList({ episodes }: EpisodeListProps) {
  const [activeIndex, setActiveIndex] = useState(0);
  const active = episodes[activeIndex];

  return (
    <section className="rounded-lg border border-background-200 bg-background-50 p-4 md:p-5">
      <div className="mb-3 flex flex-wrap items-center justify-between gap-2">
        <h2 className="flex items-center gap-2 text-lg font-bold text-foreground-950">
          <span className="h-5 w-1 rounded-full bg-primary-500"></span>
          剧集列表
        </h2>
        <span className="flex items-center gap-1 rounded-full bg-accent-100 px-3 py-1 text-xs text-accent-700">
          <i className="ri-information-line"></i>
          仅提供简介浏览，暂不支持在线播放
        </span>
      </div>

      <div className="grid grid-cols-1 gap-4 lg:grid-cols-[260px_minmax(0,1fr)]">
        <div className="flex flex-wrap gap-2 lg:max-h-80 lg:flex-col lg:overflow-y-auto lg:pr-1">
          {episodes.map((episode, index) => (
            <button
              key={episode.index}
              type="button"
              onClick={() => setActiveIndex(index)}
              className={`flex w-full cursor-pointer items-center justify-between gap-2 rounded-md border px-3 py-2 text-left text-sm transition-colors ${
                index === activeIndex
                  ? "border-primary-400 bg-primary-50 text-primary-700"
                  : "border-background-200 text-foreground-600 hover:border-primary-300 hover:text-primary-600"
              }`}
            >
              <span className="line-clamp-1">{episode.title}</span>
              <i className="ri-play-circle-line shrink-0 text-base"></i>
            </button>
          ))}
        </div>

        <div className="rounded-lg bg-background-100 p-4 md:p-5">
          <h3 className="text-base font-semibold text-foreground-900">{active.title}</h3>
          <p className="mt-3 text-sm leading-7 text-foreground-600">{active.summary}</p>
          <p className="mt-4 flex items-center gap-2 text-xs text-foreground-400">
            <i className="ri-cursor-line"></i>
            当前为演示内容，切换仅更新文字简介
          </p>
        </div>
      </div>
    </section>
  );
}